export default __webpack_public_path__ + "static/media/phone-1@2x.f465a2af.png";